import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  onClick?: () => void;
  hoverable?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className = '', title, onClick, hoverable = false }) => {
  const hoverStyles = hoverable ? 'cursor-pointer hover:scale-105 transition-transform duration-200' : '';

  return (
    <div
      className={`ff-window ${hoverStyles} ${className}`}
      onClick={onClick}
    >
      {title && (
        <div className="border-b-2 border-[#533483] mb-4 pb-2">
          <h3 className="text-pixel-base text-[#e94560]">{title}</h3>
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
